<template>
  <el-button type="text"
             title="全屏"
             @click='click'><i class="el-icon-full-screen"></i></el-button>
</template>

<script>
import screenfull from 'screenfull';

export default {
  name: 'screenfull',
  computed: {},
  data() {
    return {
      isFullscreen: false
    };
  },
  methods: {
    click() {
      if (!screenfull.enabled) {
        this.$message({
          message: '你的浏览器不支持',
          type: 'warning'
        });
        return false;
      }
      /* this.isFullscreen=!this.isFullscreen*/
      screenfull.toggle();
    }
  }
};
</script>

<style scoped>
i {
  font-size: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/screenfull/index.vue